import LayoutGestao from './layouts/Main.vue'
import ModuleMixin from './shared/mixins/ModuleMixin';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [
        BaseGestaoMixin,
        ModuleMixin,
    ],
    components: {
        LayoutGestao,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'loading',
            locale: 'localeCode',
            localeAllowed: 'localeAllowed',
        }),
        defaultLocale() {
            let locales = this.localeAllowed;
            return locales.length ? locales[0] : null;
        },
        isSingleLocale() {
            return this.localeAllowed.length <= 1;
        },
        filterLocale() {
            return this.localeAllowed.concat([{code: '', id: 'all', name: 'Todas as linguas'}]);
        },
    },
    methods: {
        setLoading(flag) {
            this.$store.dispatch('setLoading', flag);
        }
    }
}
